var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTtdLogoGreen = function SvgTtdLogoGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3851 1.018L19.4501 1.034L32.7781 4.678C33.4131 4.852 33.8601 5.415 33.8901 6.067L33.8921 6.137V19.15H46.9851C47.7981 19.15 48.4601 19.791 48.4951 20.595L48.4971 20.662V33.336C48.4971 34.149 47.8571 34.812 47.0521 34.847L46.9851 34.849H33.8921V47.863C33.8921 48.544 33.4361 49.142 32.7781 49.322L19.4501 52.966C18.6441 53.186 17.8131 52.712 17.5931 51.906C17.5571 51.776 17.5391 51.642 17.5391 51.507V2.493C17.5391 2.358 17.5571 2.223 17.5931 2.093C17.8011 1.333 18.5551 0.867 19.3171 1.003L19.3851 1.018Z",
    fill: "#52CB94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38105 34.85H16.0271C16.8621 34.85 17.5391 34.173 17.5391 33.337V20.663C17.5391 19.828 16.8621 19.151 16.0271 19.151H2.01505C1.18005 19.151 0.503052 19.828 0.503052 20.663V33.337C0.503052 34.173 1.18005 34.85 2.01505 34.85H9.38105Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.01569,
    y1: 27.0005,
    x2: 15.6632,
    y2: 27.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44696,
    stopColor: "#52CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CB94",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTtdLogoGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ttd-logo-green.e804f3ab01d3b95e28e39f4562bfe711.svg";